import * as React from 'react';

import { UrlHelpers } from '../../service/UrlHelpers';
import { CampaignType } from '../../typings/domain';

import './GroupsEditFrame.css';

export interface GroupEditFrameProps {
    groupIds?: string[];
    bannerIds?: string[];
    campaignId: string;
    campaignType: CampaignType;
    login: string;
    onLoad?: () => void;
    anchor?: string;
}

export class GroupsEditFrame extends React.PureComponent<GroupEditFrameProps> {
    render() {
        const {
            groupIds,
            bannerIds,
            campaignId,
            campaignType,
            login,
            onLoad,
            anchor
        } = this.props;

        if (onLoad === undefined) {
            return null;
        }

        const url =
            groupIds !== undefined
                ? UrlHelpers.getDirectLink(
                      UrlHelpers.getEditGroupCmdByCampaignType(campaignType),
                      {
                          ...UrlHelpers.getEditGroupsUrlParams(
                              groupIds,
                              campaignId,
                              login,
                              bannerIds
                          ),
                          popupMode: '1'
                      },
                      anchor
                  )
                : UrlHelpers.getDirectLink(
                      UrlHelpers.getAddGroupCmdByCampaignType(campaignType),
                      {
                          ...UrlHelpers.getAddGroupsUrlParams(
                              campaignId,
                              login
                          ),
                          popupMode: '1'
                      },
                      anchor
                  );

        return (
            <iframe
                className="groups-edit-frame"
                frameBorder="0"
                src={url}
                onLoad={e => onLoad()}
            />
        );
    }
}
